import { useEffect } from 'react';
import { usePrevious } from 'react-use';

import { useSetAtom } from 'jotai';

// Hooks
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

// Atoms
import { openedMessageAtom } from '@/components/pages/conversations/SocialInbox/atoms';

/**
 * Hook to reset the opened message when active profile or group changes
 */
export const useResetOpenedMessageOnProfileChange = () => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeGroup } = useActiveGroup();
    const setOpenedMessage = useSetAtom(openedMessageAtom);

    const previousActiveGroup = usePrevious(activeGroup);
    const previousActiveSocialProfile = usePrevious(activeSocialProfile);

    useEffect(() => {
        // Skip initial render when previous values are null
        if (!previousActiveGroup && !previousActiveSocialProfile) {
            return;
        }

        // Check if either group or profile has changed
        const hasChanged =
            previousActiveGroup?.id !== activeGroup?.id ||
            previousActiveSocialProfile?.id !== activeSocialProfile?.id;

        if (hasChanged) {
            setOpenedMessage(null);
        }
    }, [
        activeSocialProfile,
        activeGroup,
        previousActiveGroup,
        previousActiveSocialProfile,
        setOpenedMessage
    ]);
};
